import React, { ReactNode } from 'react';

import { FieldRenderProps } from 'react-final-form';

import FieldWrapper from '../field-wrapper/field-wrapper';

export interface CheckboxGroupProps extends FieldRenderProps<string | string[] | number, HTMLInputElement> {
  children?: ReactNode;
  /** Allows the component to get additional styles. */
  className?: string;
  /** Checks if the field is disabled. */
  isDisabled?: boolean;
  /** Checks if the field is hidden. */
  isHidden?: boolean;
  /** Checks if the field is required to submit. */
  isRequired?: boolean;
}

const CheckboxGroup = ({
  children,
  className,
  customErrorMessage,
  id,
  isDisabled = false,
  isFullWidth = false,
  isHidden = false,
  isRequired = false,
  label,
  meta,
  ...rest
}: CheckboxGroupProps) => {
  const hasError = meta?.error && meta?.touched;
  const errorMessage = customErrorMessage || meta?.error;
  const labelId = `checkboxGroup-${id}`;

  return (
    <FieldWrapper
      {...rest}
      isCheckboxGroup
      aria-labelledby={labelId}
      css={{
        display: 'flex',
        flexDirection: 'column'
      }}
      // eslint-disable-next-line react/jsx-sort-props
      className={className}
      customErrorMessage={errorMessage}
      hasError={hasError}
      id={id}
      isDisabled={isDisabled}
      isFullWidth={isFullWidth}
      isHidden={isHidden}
      isRequired={isRequired}
      label={label}
      labelId={labelId}
      labelVariant="headlineS"
      meta={meta}
    >
      {children}
    </FieldWrapper>
  );
};

export { CheckboxGroup };
export default CheckboxGroup;
